module.exports = __webpack_public_path__ + "static/img/aepic-17.16b684d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/aepic/aepic-17.jpg
// module id = 3pk3
// module chunks = 51